<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
    },
    data() {
        return {
            errors: {},
            form: {
                files: [],
            },
            send: false,
        }
    },
    methods: {
        closedModal() {
            this.form.files = [];
            this.send = false;
            this.errors = {};
            this.$modal.hide('addFiles');
        },
        uploadFilesBill(event) {
            let vm = this;

            let droppedFiles = event.target.files;
            if (!droppedFiles) return;
            [...droppedFiles].forEach(function (valor) {
                vm.form.files.push(valor);
            });
            this.$forceUpdate();
        },
        dragFilesBill(event) {
            let vm = this;

            let droppedFiles = event.dataTransfer.files;
            if (!droppedFiles) return;
            [...droppedFiles].forEach(function (valor) {
                vm.form.files.push(valor);
            });
            this.$forceUpdate();
        },
        delImg(pos) {
            this.form.files.splice(pos, 1);
            this.successNotification('El archivo se elimino correctamente.');
        },
        async sendFiles() {
            this.send=true;
            const data_form = new FormData();
            this.form.files.forEach(function (valor, index) {
                data_form.append('xmls[' + index + ']', valor);
            });

            let _endpoint = `/bill_download`;

            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (!data.ok) {
                    this.$swal({
                        icon: 'error',
                        title: 'No se pudieron cargar todas las facturas',
                        text: data.error
                    });
                }
                if(data.continue){
                    Event.$emit('event-multifiles-list',data.totales, data.guardadas, data.validas, data.no_validas, data.complementos, data.temporales);
                    this.closedModal();
                }
                this.send=false;
                this.form.files = [];
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {

                    this.errors = await this.errorNotification(error);
                }
            }
        },
        //check

        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    watch: {
    },
    mounted() {
    },
    created() {
        Event.$on("event-show-addFiles", async () => {
            this.$modal.show('addFiles');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}
</script>
<template>
    <modal name="addFiles" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="sendFiles" method="post" enctype="multipart/form-data">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">XMLs a Cargar</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <hr>
                        <div class="row">
                            <div @dragover.prevent @drop.prevent class="col-12 text-center">
                                <h3>Archivos adjuntos.</h3>
                                <div @drop="dragFilesBill" class="row mt-4 mb-4">
                                    <div class="col-12" v-if="(form.files.length) == 0">
                                        <i class="fa-solid fa-file fa-4x"></i>
                                        <p>Sin archivos adjuntos</p>
                                    </div>
                                    <div class="col-md-4 col-12 p-2" v-for="(img, index_img) in form.files"
                                        :key="index_img" v-show="form.files.length > 0">
                                        <div>
                                            <button v-if="prop_edit" class="btn btn-sm btn-danger del" type="button"
                                                @click="delImg(index_img)"><i class="fa fa-trash"></i></button>
                                                <p>{{ img.name }}</p>
                                        </div>
                                    </div>
                                </div>


                                <div class="input-group mb-3"
                                    v-if="(form.files.length) <= 14 && prop_edit">
                                    <div class="custom-file" @change="uploadFilesBill">
                                        <input type="file" multiple class="custom-file-input" id="inputGroupFile03"
                                            aria-describedby="inputGroupFileAddon03">
                                        <label class="custom-file-label" for="inputGroupFile03">
                                            Subir Archivo
                                        </label>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" :disabled="send" type="submit"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Procesando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Enviar
                            </span>
                        </button>
                        <button type="button" :disabled="send" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<style scoped>
.image-upload>input {
    display: none;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>